class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('.js-search-input');
    this.searchLink = document.querySelectorAll('.js-open-search');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.defaultBlocks = document.querySelectorAll('.js-default-search-block');
    this.searchContainer = document.querySelector('.js-header-search');
    this.searchClose = document.querySelectorAll('.js-search-background-close, .js-close-search');
    this.searchBackground = document.querySelector('.js-search-background-close');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.searchLink.forEach(searchLink => {
      searchLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.toggleSearchContainerClass(true);
      });
    });

    this.searchClose.forEach(searchClose => {
      searchClose.addEventListener('click', (event) => {
        event.preventDefault();
        this.toggleSearchContainerClass(false);
      });
    });

    this.getSearchBanner();
  }

  getSearchBanner() {
    const sourceElement = document.querySelector(".js-search-banner");
    const targetElement = document.querySelector(".js-get-search-banner");
    
    if (sourceElement && targetElement) {
      targetElement.innerHTML = sourceElement.innerHTML;
    }
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        if (typeof initializeObservers === "function") {
          initializeObservers();
        }
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
    this.predictiveSearchResults.classList.add('active');
    this.defaultBlocks.forEach(block => block.classList.add('d-none'));
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
    this.predictiveSearchResults.classList.remove('active');
    this.defaultBlocks.forEach(block => block.classList.remove('d-none'));
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  toggleSearchContainerClass(isActive) {
    if (this.searchContainer) {
      if (isActive) {
        this.searchContainer.classList.add('display');
        this.searchBackground.classList.add('display');
        setTimeout(() => {
          this.searchContainer.classList.add('active');
          this.searchBackground.classList.add('active');
        }, 50)
      } else {
        this.searchContainer.classList.add('closing');
        this.searchBackground.classList.add('closing');
        setTimeout(() => {
          this.searchContainer.classList.remove('active', 'closing', 'display');
          this.searchBackground.classList.remove('active', 'closing', 'display');
        }, 300);
      }
    }
  }
}

customElements.define('predictive-search', PredictiveSearch);